import { render } from "./EventspanelCollapsible.vue?vue&type=template&id=2811d31a&scoped=true"
import script from "./EventspanelCollapsible.vue?vue&type=script&lang=js"
export * from "./EventspanelCollapsible.vue?vue&type=script&lang=js"

import "./EventspanelCollapsible.vue?vue&type=style&index=0&id=2811d31a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2811d31a"]])

export default __exports__